import React from 'react'

export const EmptyCartIcon = () => (
  <svg width="130" height="131" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m18.017 26.539-2.202-15.907a2.507 2.507 0 0 1 4.963-.71l2.293 15.496-5.054 1.12z"
      fill="#E4E4E4"
    />
    <path
      d="m28.957 9.699-22.71-.345a1.945 1.945 0 0 1-1.548-.806c-.924-1.28-.021-3.068 1.556-3.085l25.724-.276a4 4 0 0 1 3.97 3.235l3.065 15.723a2.161 2.161 0 1 1-4.254.758L32.845 13.06A4 4 0 0 0 28.957 9.7z"
      fill="#E4E4E4"
    />
    <circle
      cx="112.306"
      cy="101.355"
      r="9.477"
      transform="rotate(9.168 112.306 101.355)"
      fill="#DDD"
    />
    <path
      d="m29.275 82.537 1.939 11.081a1.176 1.176 0 0 0 1.846.751c.253-.183.568-.257.876-.207l.167.027a1.585 1.585 0 0 0 1.825-1.773l-1.247-9.428-.691.112a4 4 0 0 1-2.044-.2l-1.524-.57a.51.51 0 0 1-.234-.178c-.316-.438-1.006-.146-.913.385z"
      fill="#E4E4E4"
    />
    <circle
      cx="49.064"
      cy="101.312"
      r="9.477"
      transform="rotate(9.168 49.064 101.312)"
      fill="#DDD"
    />
    <path
      d="m44.995 83.953 2.649 15.327a1.173 1.173 0 0 0 1.843.751c.252-.182.567-.257.874-.207l.143.023a1.523 1.523 0 0 0 1.74-1.778l-2.616-14.3a1.676 1.676 0 0 0-2.15-1.297l-.845.265a1.021 1.021 0 0 1-.468.033 1.022 1.022 0 0 0-1.17 1.183z"
      fill="#E4E4E4"
    />
    <path
      d="m111.163 104.627-68.127-.633a2.437 2.437 0 0 1 .014-4.873l68.13-.243a2.874 2.874 0 1 1-.017 5.749z"
      fill="#E4E4E4"
    />
    <circle
      cx="34.221"
      cy="102.304"
      r="9.477"
      transform="rotate(9.168 34.221 102.304)"
      fill="#E6E6E6"
    />
    <circle
      cx="96.362"
      cy="102.167"
      r="9.477"
      transform="rotate(9.168 96.362 102.167)"
      fill="#E6E6E6"
    />
    <circle
      cx="34.221"
      cy="102.304"
      r="5.017"
      transform="rotate(9.168 34.221 102.304)"
      fill="#fff"
    />
    <circle
      cx="96.362"
      cy="102.171"
      r="5.017"
      transform="rotate(9.168 96.362 102.171)"
      fill="#fff"
    />
    <path
      d="M27.785 80.128 17.39 29.663a4 4 0 0 1 3.904-4.807l88.34-.31 15.018-.054a4 4 0 0 1 3.957 4.673l-8.931 52.314a4 4 0 0 1-4.086 3.325l-23.454-.837-60.478-.646a4 4 0 0 1-3.875-3.193z"
      fill="#EBEBEB"
    />
    <path
      d="m128.756 29.374-8.872 51.949a4.001 4.001 0 0 1-4.089 3.323l-23.449-.853 3.364-.354a4 4 0 0 0 3.511-3.23l10.562-55.47 15.02-.039a4 4 0 0 1 3.953 4.674z"
      fill="#E4E4E4"
    />
    <rect
      width="3.324"
      height="33.495"
      rx="1.662"
      transform="matrix(.9908 -.13537 .22586 .97416 32.745 37.84)"
      fill="#DDD"
    />
    <rect
      width="3.339"
      height="33.243"
      rx="1.669"
      transform="matrix(.99742 -.07177 .1212 .99263 47.451 37.293)"
      fill="#DDD"
    />
    <rect
      width="3.336"
      height="33.294"
      rx="1.668"
      transform="matrix(.9961 .08817 -.14855 .9889 79.27 37.293)"
      fill="#DDD"
    />
    <rect
      width="3.324"
      height="33.497"
      rx="1.662"
      transform="matrix(.99074 .13577 -.22651 .974 94.492 37.293)"
      fill="#DDD"
    />
    <rect
      width="3.344"
      height="33.151"
      rx="1.672"
      transform="matrix(.99978 .02115 -.03588 .99936 64.56 37.293)"
      fill="#DDD"
    />
  </svg>
)
